// extracted by mini-css-extract-plugin
export default {"colors":"\"./../../constants/index.css\"","color_main":"#ffb74d","color_grey":"#d8d8d8","xxIcon":"FormTreePanel_xxIcon__kp0CF"};